export default {
  namespaced: true,
  state () {
    return {
      backLinkEnabled: false,
      breadcrumbs: [],
      pageTitle: null,
      helpUrl: null,
      helpDescription: '',
      isGlobalPageHeaderHidden: false
    }
  },
  getters: {
    isGlobalPageHeaderHidden: state => state.isGlobalPageHeaderHidden
  },
  actions: {
    SET_PAGE_TITLE({ commit }, title) {
      commit('SET_PAGE_HEADER_TITLE', title)
      commit('SET_DOCUMENT_TITLE', title)
    }
  },
  mutations: {
    SET_BREADCRUMBS (state, items) {
      if (!items) return

      state.breadcrumbs = items.map(item => {
        if (typeof item === 'string') {
          const crumb = {
            text: item
          }
          switch (item) {
            case 'My Atlas':
              crumb.to = '/develop/dashboard'
              break
            case 'My Lessons':
              crumb.to = { name: 'LessonsCalendarWeek' }
              break
            case 'Admin':
              crumb.to = '/admin'
              break
            case 'Super Admin':
              crumb.href = '/Atlas/SuperAdmin/View/Default' // '/super-admin'
              break
            case 'Curriculum Process Assistant':
              crumb.to = '/admin/assistant-template'
              break
            default:
              crumb.active = true
          }
          return crumb
        }
        return item
      })
    },
    SET_PAGE_HEADER_TITLE (state, title) {
      state.pageTitle = title
    },
    SET_DOCUMENT_TITLE (state, title) {
      document.title = title
    },
    SET_HELP_URL (state, url) {
      state.helpUrl = url
    },
    SET_HELP_DESCRIPTION (state, text) {
      state.helpDescription = text
    },
    SET_IS_PAGE_HEADER_HIDDEN (state, isHidden) {
      state.isGlobalPageHeaderHidden = isHidden
    },
    SET_BACK_LINK_ENABLED (state, enabled) {
      state.backLinkEnabled = enabled
    }
  }
}
